// version.js
export const app_ver = '1.0.5'; // Named export
//export const date = '16-11-2024'; // Named export
// export const date = '09-01-2025'; version 2
export const date = '31-01-2025';

// If you want a default export as well
const defaultExport = { app_ver, date };
export default defaultExport;
